import * as React from "react";

const SvgIcnFlexDebugger = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
        <path
            d="M15.646 5H4.542c-.3 0-.542.243-.542.542v7.041c0 .3.243.542.542.542h11.104c.299 0 .541-.242.541-.542V5.542c0-.3-.242-.542-.541-.542zM7.656 15.156h4.875M10.094 13.125v2.031"
            stroke="#AEB2C1"
            strokeWidth={1.25}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.715 8.724h-.397a.204.204 0 01-.169-.09l-1.37-2.056a.204.204 0 00-.351.022l-2.124 4.248a.203.203 0 01-.351.022l-1.37-2.056a.204.204 0 00-.17-.09h-1.01"
            stroke="#AEB2C1"
            strokeWidth={1.25}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default SvgIcnFlexDebugger;
